import { Button } from '@fluentui/react-components'
import React from 'react'
import { t } from '../../i18n/i18n'
import { UserMessage } from '../common/messageBar/UserMessage'

type NoLawsFoundMessageBarProps = {
   /** Swaps in search-specific copy and a clear action, rather than the generic "adjust your filters" text. */
   isSearching?: boolean
   onClearSearch?: () => void
}

export const NoLawsFoundMessageBar = ({ isSearching, onClearSearch }: NoLawsFoundMessageBarProps) => {
   return (
      <UserMessage
         title={isSearching ? 'NoSearchResultsTitle' : 'NoResultByFilter'}
         message={isSearching ? 'NoLawSearchResults' : 'AdjustFilterToFindWhatYoureLookingFor'}
         action={isSearching && onClearSearch ? <Button onClick={onClearSearch}>{t('ClearSearch')}</Button> : undefined}
      />
   )
}
